import NoExplanations from '../components/NoExplanations'
import {connect} from 'react-redux'
import {showModal} from '../../../redux/modules/modal'
import {handleNewContent} from '../../../redux/modules/topic'

const mapStateToProps = state => {
  return {
    topicId: state.getIn(['topic','topic'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    openCreateEditor: (topicId) => {
      dispatch(showModal('CONTENT_EDITOR',{
        contentOrTopicId: topicId,
        createOrEdit:'create',
        contentType:'explanation',
        handleNewContent: (newContent) => {
          dispatch(handleNewContent(topicId, newContent))
        }
      }))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoExplanations)



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleNoExplanations.js